import TrainlineIcon from './TrainlineIcon';

export default TrainlineIcon;